module.exports = __webpack_public_path__ + "media/global_smart_banner/gsb-star-rating-ddacd474.svg";